/*
 * @Author: tianzhi
 * @Date: 2019-08-08 14:53:41
 * @Last Modified by: mikey.zhaopeng
 * @Last Modified time: 2021-01-19 14:05:04
 */
import SpinLoading from '@/components/SpinLoading';
import { getMessageRead, APPConfig, getIcoAndCompanyName, lateLearn, getRegisterConfig, personalLeftMenu } from '@/fetch/api/personal.js';
import { getBaseInfo, getPersonConfig, getCurrentUser, queryBranchSchoolList, queryMenuList, querySuebjectLibAuth, querySystemColor, getSchoolIndepent, getSystemFooter, headConfig, selectedSchool, saveSessionSchoolId, getCompanyCodeInfo, getConfigNode, getFindMarket, getTimeZoneConfig } from '@/fetch/api/settings';
import { getToken, getUserInfo, loginOut, getOauthToken, checkPwdUpdate } from '@/fetch/api/token.js';
import { TEACHER_PAGE_INIT } from "../../services/teacher.js";
import { getCookie, removeAllCookie } from '@/utils/cookie';
import * as layoutActions from '@/models/layout/actions';
import { GetIsBottom as isBottomActions } from '@/models/payment/actions';
import * as personalActions from '@/models/personal/actions';
import history from '@/router/history';
import { Decrypt, Encrypt } from '@/utils/encrypt.js';
import { Local } from '@/utils/local.js';
import { themeColor } from '@/utils/themeColor.js';
import { delUrlParmas, getUrlParmas, delMoreUrlParams } from '@/utils/urlSearch.js';
import { Alert, Dropdown, ConfigProvider, Menu, Badge, message } from 'antd';
import zhCN from 'antd/es/locale-provider/zh_CN';
import classnames from 'classnames';
import moment from 'moment';
import 'moment/locale/zh-cn';
import $ from 'jquery';
import { withRouter } from "react-router";
import React, { Component } from 'react';
import { connect } from 'react-redux';
import RouterView from '../../router/router-view';
import { bindActionCreators } from 'redux';
import axios from 'axios'; // 国际化配置
// import { IntlProvider, FormattedMessage } from 'react-intl';
// import en_US from "../../locale/en_US";
// import zh_CN from "../../locale/zh_CN";
// 国际化配置

import intl from 'react-intl-universal';
import zh from '../../locale/zh_CN.js';
import en from '../../locale/en_US.js';
import SideLayer from './SideLayer';
import Footer from './Footer';
import DelicateHeader from './Header/DelicateHeader';
import ElegantHeader from './Header/ElegantHeader';
import WindHeader from './Header/WindHeader';
import LoginRegister from './LoginRegister';
import './style.less';
import WebSocketProxy from '@/utils/webSocket';
import WebSocket from '@/utils/webSocket/wsMiddle';
import WebSocketConfig from '@/utils/webSocket/wsConfig';
moment.locale('zh-cn');
const {
  SubMenu
} = Menu;

const logoUrl = require('@/statics/img/logo.png');

const headBgUrl = require('@/statics/img/head-bg.png');

const favIcon = require('@/statics/img/favicon.ico');

let getFoot = 0;

class Layout extends Component {
  constructor(props, context) {
    super(props, context), this.state = {
      userId: Local.get('userInfo') && JSON.parse(Decrypt(Local.get('userInfo'))).userId ? Number(JSON.parse(Decrypt(Local.get('userInfo'))).userId) : null,
      currMenuName: null,
      schoolId: localStorage.getItem('schoolId') ? localStorage.getItem('schoolId') : null,
      companyId: localStorage.getItem('userInfo') ? JSON.parse(Decrypt(localStorage.getItem('userInfo'))).companyId : 1,
      schoolList: [],
      //分校列表
      headMenuList: [],
      //头部菜单列表
      footMenuList: [],
      //底部菜单列表
      currentSchoolName: '',
      //当前学校名称
      currentMenu: '',
      //当前选中的菜单
      isLogin: false,
      //是否已登录
      // 导航颜色
      menuColor: 'dark',
      refresh_loading: true,
      refresh_token_loading: true,
      clientHeight: (document.documentElement.clientHeight || document.body.clientHeight) > 185 ? (document.documentElement.clientHeight || document.body.clientHeight) - 185 : document.documentElement.clientHeight || document.body.clientHeight,
      userInfo: null,
      //用户信息
      baseInfo: null,
      //机构基本信息
      personConfigInfo: [],
      //用户配置信息
      currentUserInfo: null,
      //当前用户的基本信息
      sideLayerInfo: null,
      //右下角浮窗信息
      baseUrl: window.location.origin,
      showSchoolList: true,
      //是否展示分校列表
      showCompanyWarning: false,
      //是否显示仅供机构测试使用的警告
      companyWarning: '',
      //警告默认信息
      lang: 'zh',
      langText: '中文',
      swithLoading: false,
      learnData: {},
      //最近学习
      lateLearnShow: false,
      appConfig: {},
      //机构app配置
      headerConfig: {},
      //机构页头配置
      currentDomain: window.location.origin.indexOf('localhost') == -1 ? window.location.origin : 'http://wxrcc.rel-s.yunduoketang.cn',
      unreadMessage: null,
      //未读的消息数量
      // personalOrQuesBankcorlor:window.location.hash.split('/')[1],
      registerConfigFlag: 1,
      // 是否开启注册功能，1关闭
      footerInfo: null,
      //页尾信息
      isBottom: false,
      //页面是否滚动到最底下
      registerConfig: null,
      dropVisible: false,
      //菜单下拉
      MenuClassName: '' //分校菜单位置控制

    };
  }

  componentWillMount() {
    this.props.layoutActions.ActionHideFooter(false);
    this.props.layoutActions.ActionHideHead(false);
    const pathname = this.props.location.pathname;

    if (this.isMobile() && this.isWap()) {
      //如果是参加考试页面，单独去页面判断跳转
      window.location.href = `${window.location.origin}/wap`;
    }

    this.setState({
      currMenuName: pathname.indexOf('system') == -1 ? '题库' : '个人中心',
      currentMenu: Local.get('currentMenu') * 1 || ''
    }); //目前url地址的问号后面只拼接code=XXX的固定格式，获取code值的时候直接截取了
    //没有用一般的获取url参数的方法是因为token值包含'='等特殊字符
    // if (Local.get('refresh_token')) { // token重连
    //   let clientId = (this.state.userId && getCookie('cookie_user_')) ? 'front' : 'frontAnonymous'
    //   getOauthToken({
    //     code: Local.get('refresh_token'),
    //     clientId
    //   }).then((res) => {
    //     if (res) {
    //       const token = res.access_token;
    //       Local.set('token', token);
    //       if (getUrlParmas("parentId")) Local.set('parentId', getUrlParmas("parentId"))
    //       if (getUrlParmas('schoolId')) Local.set('schoolId', getUrlParmas('schoolId'))
    //       // let url = window.location.href
    //       // if (url.indexOf('code=') !== -1) {
    //       //   url = delUrlParmas('code');
    //       //   url = url.split("?")[0];
    //       //   console.log('url',url)
    //       //   window.location.href = url
    //       // }
    //       this.fetchUserInfoData(token);
    //       this.handleSchoolId()
    //       if (Local.get('refreshFlag')) {
    //         Local.remove('refreshFlag')
    //       }
    //       return
    //     }
    //     message.destroy()
    //     message.warning("您的账号信息已过期，请重新登录")
    //     this.handleInvalidJump()
    //     localStorage.clear()
    //   }).catch(err => {
    //     if (!Local.get('refreshFlag')) {
    //       message.destroy()
    //       message.warning("您的账号信息已过期，请重新登录")
    //       this.handleInvalidJump()
    //     }
    //     Local.set('refreshFlag', true)
    //     // localStorage.clear()
    //   });
    // } else

    if (window.location.href.indexOf('?code=') > 0 || window.location.href.indexOf('&code=') > 0) {
      const code = getUrlParmas("code");
      if (getUrlParmas("parentId")) Local.set('parentId', getUrlParmas("parentId"));
      if (getUrlParmas('schoolId')) Local.set('schoolId', getUrlParmas('schoolId'));
      this.fetchTokenData(code);
    } else if (Local.get('token')) {
      let token = Local.get('token');
      this.fetchUserInfoData(token);
      this.handleSchoolId(); // this.getBranchSchoolList()
      // this.getSchoolIndependent()
      // this.getDefaultDatas()
      // this.getLateLearn()
      // this.getAPPConfig()
    } else {
      this.handleInvalidJump();
    }
  }

  componentDidMount() {
    // 国际化初始化
    this.initInternational();
    let light_color = ['header-white', 'header-gray'];

    if (localStorage.main_color == 'white' || localStorage.main_color == 'gray') {
      this.setState({
        menuColor: 'light'
      });
    } else {
      this.setState({
        menuColor: 'dark'
      });
    }

    this.handleChangePassordClick(); // 深海定制

    if (window.location.href.indexOf('companyMessageReach=ok') !== -1) {
      Local.remove('indexShowFlag');
      Local.set('url', window.location.href);
      history.push('/personal/message/detailslist');
    } // this.checkLoginStatus();

  }

  componentDidUpdate(prevProps) {
    let url = window.location.href;

    if (prevProps.location.pathname !== this.props.location.pathname) {
      // 地址变化时处理
      //更多分校页面跳进该页面处理
      if (url.indexOf("choiceSchool") > 0) {
        let school = Local.get('school');

        if (school) {
          this.handleSchoolClick(JSON.parse(school));
        }
      }

      if (['/home/index', '/'].includes(this.props.location.pathname)) {
        let currentMenu = this.state.headMenuList.length && this.state.headMenuList[0].pageHeadType === "SYS_PAGE_HEAD_HOME" ? 0 : undefined;
        this.setState({
          currentMenu
        });
      } // 根据地址变化修改websocket鉴权里的module


      if (this.props.location.pathname.indexOf('doing') == -1 && WebSocketProxy && WebSocketProxy.general) {
        WebSocketProxy.startWebsocket('general', 'yunduo');
      } // 做题页面导航出


      if (this.props.location.pathname.indexOf('/lib/subject') !== -1) {
        let index = this.state.headMenuList.findIndex(value => value.pageHeadType === 'SYS_PAGE_HEAD_TIKU');
        this.setState({
          currentMenu: index
        });
        Local.set('currentMenu', index);
      }

      this.activeRouter(this.state.headMenuList, this.props.history.location.pathname);
    }

    if (this.props.personal.changePasswordConfig == 1 || prevProps.personal.changePasswordConfig != this.props.personal.changePasswordConfig) {
      this.handleChangePassordClick();
    }
  } // 判断当前激活的是什么页面，激活对应的路由


  activeRouter(list, url) {
    // console.log(list,url)
    const menuObj = {
      'tikuIndex/toIndex': '/lib/subject',
      'liveOpenCourse/toOpenClass': '/openCourse',
      'classPackage/findAll': '/coursePackage/list',
      'companyGroup/groupIndex': '/group',
      'sysConfigTeacher/teachers': '/teachers',
      'studentStar/findByPage': '/StudentsVoice',
      'sysNews/list': '/news',
      'signup/toSigUpPage': '/apply',
      'question/comQuestionIndex': '/answerslist/0',
      'teacherSettle/teacherInfo': '/teacherLoginIn',
      'companyMemberConfig/toVip': '/vip'
    };
    let keyName = '';

    for (const key in menuObj) {
      if (menuObj.hasOwnProperty(key)) {
        const element = menuObj[key];

        if (element == url) {
          keyName = key;
        }
      }
    }

    list.forEach((ele, index) => {
      if (ele.menuUrl == keyName) {
        this.setState({
          currentMenu: index
        });
      }
    });
  }

  componentWillUnmount() {
    this.langTimer = null;
    window.removeEventListener('click', this.handleChangePassord, true);
  }

  checkLoginStatus = () => {
    let userId = null;

    if (Local.get('userInfo')) {
      let userInfo = JSON.parse(Decrypt(Local.get('userInfo')));
      userId = userInfo.userId ? userInfo.userId : null;
    }

    console.log(userId, "是否登陆======");

    if (userId) {
      axios({
        url: `${this.state.currentDomain}/v1/checkUserStatus`,
        method: 'get'
      }).then(res => {
        try {
          if (res < 1) {
            const hash = `${window.location.pathname}${window.location.hash}`;
            const queryString = window.encodeURIComponent(hash);
            window.location.href = `${window.location.origin}/upgrade/token?callback=${queryString}`;
            localStorage.clear();
          }
        } catch (error) {
          console.log(error);
        }
      });
    }
  };
  isWap = () => {
    const pathname = this.props.location.pathname;
    let result = true;
    let pathnameArr = ['/lib/subject', '/lib/subject/exampaper/examintro/', '/lib/subject/exampaper/payresult', '/course/detail', '/coursePackage/detail', '/openCourse', '/coursePackage/list', '/course/list', '/class/type', '/answerslist', '/response', '/teachers', '/teachersdetail', '/group', '/groupdetail', '/news', '/newsdetails', '/vip', '/payment/order'];

    for (var i = 0; i < pathnameArr.length; i++) {
      if (pathname.indexOf(pathnameArr[i]) != -1) {
        result = false;
        break;
      }
    }

    return result;
  };
  handleChangePassordClick = () => {
    //如果后台配置了强制修改密码，增加拦截点击事件逻辑
    if (this.props.personal.changePasswordConfig == 1) {
      Local.remove('indexShowFlag');
      window.addEventListener('click', this.handleChangePassord, true);
    } else {
      window.removeEventListener('click', this.handleChangePassord, true);
    }
  };
  changeMenu = () => {
    //点击了头像跳转个人中心
    this.setState({
      currentMenu: -1
    });
  };
  getCompanyCode = () => {
    getCompanyCodeInfo({
      schoolId: Local.get('schoolId') ? Local.get('schoolId') : null
    }).then(res => {
      if (res.code == '1') {
        if (!res.data) {
          return;
        }

        let statKey = res.data.statKey;

        switch (res.data.statType) {
          case 'baidu':
            let hm = document.createElement("script");
            hm.src = `//hm.baidu.com/hm.js?${statKey}`;
            let s = document.getElementsByTagName("script")[0];
            s.parentNode.insertBefore(hm, s);
            break;

          case 'google':
            (function (i, s, o, g, r, a, m) {
              i['GoogleAnalyticsObject'] = r;
              i[r] = i[r] || function () {
                (i[r].q = i[r].q || []).push(arguments);
              }, i[r].l = 1 * new Date();
              a = s.createElement(o), m = s.getElementsByTagName(o)[0];
              a.async = 1;
              a.src = g;
              m.parentNode.insertBefore(a, m);
            })(window, document, 'script', '//www.google-analytics.com/analytics.js', 'ga');

            ga('create', `UA-${statKey}`, 'auto');
            ga('send', 'pageview');
            break;

          case 'cnzz':
            let cnzz_protocol = "http:" == document.location.protocol ? "http://" : "http://";
            let sRoot = document.getElementById("root");
            let sSpan = unescape(`%3Cspan id='cnzz_stat_icon_${statKey}' style='display:none;'%3E%3C/span%3E`);
            let hmCnzzt = document.createElement("script");
            let sCnzzt = document.getElementsByTagName("script")[0];
            hmCnzzt.src = `${cnzz_protocol}s11.cnzz.com/z_stat.php?id=${statKey}`;
            sRoot.insertAdjacentHTML('afterend', sSpan);
            sCnzzt.parentNode.insertBefore(hmCnzzt, sCnzzt);
            break;

          case 'tencent':
            let hmTencent = document.createElement("script");
            hmTencent.src = `//tajs.qq.com/stats?sId=${statKey}`;
            let sTencent = document.getElementsByTagName("script")[0];
            sTencent.parentNode.insertBefore(hmTencent, sTencent);
            break;

          default:
            break;
        }
      }
    });
  };
  handleChangePassord = e => {
    var target = $(e.target);

    if (target.closest(".change-password-view").length == 0 && target.closest(".logout").length == 0 && target.closest(".ant-modal-root").length == 0) {
      e.preventDefault();
      e.stopPropagation();
      message.destroy();
      message.warning('根据相关要求，请修改您的密码后继续使用');
      history.push('/personal/setting/account');
      return false;
    }
  };
  handleInvalidJump = () => {
    const hash = `${window.location.pathname}${window.location.hash}`;
    const queryString = window.encodeURIComponent(hash);
    window.location.href = `${window.location.origin}/upgrade/token?callback=${queryString}`;
  };
  initInternational = () => {
    let lang = this.state.lang || navigator.languages && navigator.languages[0] || navigator.language.split('-')[0];
    intl.init({
      currentLocale: lang,
      locales: {
        zh,
        en
      }
    });
  };
  handleSchoolId = () => {
    let url = decodeURI(window.location.href);
    var nameValue;

    if (url.indexOf("schoolId") > 0) {
      var paraString = url.substring(url.indexOf("?") + 1, url.length).split("&");
      var paraObj = {};

      for (var i = 0; nameValue = paraString[i]; i++) {
        var name = nameValue.substring(0, nameValue.indexOf("="));
        var value = nameValue.substring(nameValue.indexOf("=") + 1, nameValue.length);

        if (value.indexOf("#") > -1) {
          value = value.split("#")[0];
        }

        paraObj[name] = value;
      }

      paraObj['id'] = paraObj['schoolId'];
      Local.set('schoolId', paraObj['schoolId']);
      this.props.layoutActions.ActionGetSchoolId(this.state.schoolId);
      this.handleSchoolClick(paraObj);
    }

    this.getCompanyCode();
  };
  handleSwitchLang = () => {
    const {
      lang
    } = this.state;
    this.setState({
      swithLoading: true,
      lang: lang == 'zh' ? 'en' : 'zh',
      langText: lang == 'zh' ? 'English' : '中文'
    }, () => {
      this.langTimer = setTimeout(() => {
        this.initInternational();
        this.setState({
          swithLoading: false
        });
      }, 500);
    });
  }; //获取机构页头配置

  getHeadConfig = () => {
    headConfig({
      domain: this.state.currentDomain
    }).then(res => {
      //headTemplateId: 页头模版 { 1=典雅页头 2=清风页头 3=精致页头 } ,
      if (res.code == '1') {
        //获取配色
        // this.getSystemColor()
        this.props.layoutActions.ActionGetNavConfig(res.data);

        if ([2, 3].includes(res.data.headTemplateId)) {
          this.setState({
            headerConfig: res.data || {},
            menuColor: 'light'
          });
          let color = 'white';
          document.body.style.setProperty('--headerBg', themeColor[color].headerBg);
          document.body.style.setProperty('--fizeColor', themeColor[color].fizeColor);
        } else {
          this.setState({
            headerConfig: res.data || {}
          });
        }
      }
    });
  }; //获取机构app配置

  getAPPConfig = () => {
    APPConfig({
      domain: this.state.currentDomain
    }).then(res => {
      // console.log('机构app配置', res)
      if (res.code == '1') {
        this.setState({
          appConfig: res.data || {}
        });
      }
    });
  }; //获取最近学习记录

  getLateLearn = () => {
    lateLearn({
      domain: this.state.currentDomain
    }).then(res => {
      // console.log('最近学习', res)
      if (res.code == '1' && res.data) {
        this.setState({
          lateLearnShow: true,
          learnData: res.data
        });
      } else {// console.log(res.data);
      }
    });
  }; // 增加ico

  getDocTitleInfo = () => {
    getIcoAndCompanyName(this.state.currentDomain).then(res => {
      if (res.code == '1') {
        this.props.layoutActions.ActionGetDoctitleInfo(res.data);
        this.changeDocTitle(res.data, this.props.location.pathname);
        history.listen(route => {
          this.changeDocTitle(res.data, route.pathname);
        });
        var head = document.getElementsByTagName('head')[0],
            linkTag = document.createElement('link');
        linkTag.setAttribute('rel', 'icon');
        linkTag.setAttribute('href', this.props.layout.doctitleConfig.icon || res.data.icon || favIcon);
        head.appendChild(linkTag);
      }
    });
  };
  changeDocTitle = (doctitleConfig, pathname) => {
    let {
      headMenuList
    } = this.state; // console.log(headMenuList, 'headMenuList');

    let courseTitle = headMenuList.filter(item => item.pageHeadType == "SYS_PAGE_HEAD_COURSE"); //课程

    let coursePackageTitle = headMenuList.filter(item => item.pageHeadType == "SYS_PAGE_HEAD_CLASS_PACKAGE"); //课程包

    if (doctitleConfig && (doctitleConfig.schoolName || doctitleConfig.companyName)) {
      Local.set('companyName', doctitleConfig.schoolName || doctitleConfig.companyName); // pathname == '/course/list' ? document.title = `${courseTitle.length && courseTitle[0].menuName}-${doctitleConfig.schoolName || doctitleConfig.companyName}` : '';//课程
      // pathname == '/' || pathname == '/home/index' ? document.title = doctitleConfig.schoolName || doctitleConfig.companyName : '';//首页
      // pathname == '/openCourse' ? document.title = `公开课-${doctitleConfig.schoolName || doctitleConfig.companyName}` : ''//公开课

      pathname == '/coursePackage/list' ? document.title = `${coursePackageTitle.length && coursePackageTitle[0].menuName}-${doctitleConfig.schoolName || doctitleConfig.companyName}` : ''; //课程包

      pathname && pathname.includes('/payment') ? document.title = `支付-${doctitleConfig.schoolName || doctitleConfig.companyName}` : ''; //支付
    }
  };

  isMobile() {
    let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
    return flag;
  } //获取token信息


  fetchTokenData = code => {
    getToken(code).then(res => {
      if (res.code === '1') {
        const token = res.data; // const refreshToken = res.message;
        // Local.set('refresh_token', refreshToken);

        Local.set('token', token); // let url = window.location.href
        // if (url.indexOf("code=") !== -1) {
        //   url = url.split("?")[0];
        //   url = delUrlParmas('code');
        // }
        // console.log('url---',url);
        // window.location.href = url

        this.fetchUserInfoData(token);
        this.handleSchoolId();
      } else {
        // code 失效 重新获取 code
        window.location.href = window.location.origin;
      }
    });
  }; //获取用户信息

  fetchUserInfoData = token => {
    this.setState({
      refresh_token_loading: true
    });
    let url = window.location.href; // 为清除首页多余参数

    if (url.indexOf("schoolId=") !== -1 || url.indexOf("code=") !== -1 || url.indexOf("parentId=") !== -1) {
      let url = window.location.href;
      url = delMoreUrlParams(['code', 'parentId', 'schoolId']); // url = url.split("?")[0];

      window.location.href = url; // history.push(url)
    }

    return new Promise((reslove, reject) => {
      getUserInfo(token).then(async res => {
        if (res) {
          const userInfo = res.principal; // console.log(userInfo)

          if (userInfo) {
            Local.set('userInfo', Encrypt(JSON.stringify(userInfo)));

            if (userInfo.userId && userInfo.userId > 0) {
              //changePasswordConfig值为1或2时需要跳转到修改密码页面（1需要强制修改密码，不修改无法进行其他操作；2不强制修改密码，还能进行其他操作）
              let changePasswordConfig = await this.checkPwdUpdateStatus();
              this.props.personalActions.GetChangePasswordConfig(changePasswordConfig);

              if (changePasswordConfig == 1 || changePasswordConfig == 2) {
                let url = window.location.href;
                Local.remove('indexShowFlag');

                if (url.indexOf('/personal/setting/account') == -1) {
                  history.replace('/personal/setting/account');
                }
              }
            }

            this.setState({
              refresh_token_loading: false,
              userId: Number(JSON.parse(Decrypt(Local.get('userInfo'))).userId),
              userInfo
            }, () => {
              // 分校列表
              this.getBranchSchoolList(); // 是否开启分校独立

              this.getSchoolIndependent(); // 是否开启注册功能

              this.getRegisterConfigFn(); // node的统计在线人数

              this.getConfigNodeFn(); // 注册WebSocket

              WebSocketConfig && WebSocketConfig.useWebSocket && WebSocket.install(WebSocketConfig.webSocketList); // 启动WebSocket

              WebSocket.general();
              WebSocketProxy.install('general'); // 获取时区设置

              this.getZoneConfig(); // 获取文档title
              // this.getDocTitleInfo();
              // console.log('userId:', this.state.userId)
            });
          }
        }
      });
      reslove();
    });
  }; //获取分校列表

  getBranchSchoolList = () => {
    // console.log(this.state.schoolId, 'loacl ----', Local.get('schoolId'));
    // if (Local.get('schoolId')) {
    //   return false;
    // }else{
    return new Promise((resolve, reject) => {
      let params = {};

      let _this = this;

      queryBranchSchoolList(params).then(res => {
        if (res.code == '1') {
          let myData = res.data;

          if (myData && myData.records && myData.records.length > 0) {
            let schoolId = '';
            schoolId = myData.records[0].id;

            if (!Local.get('schoolId')) {
              // console.log('myData.records[0].id', myData.records[0].id);
              Local.set('schoolId', myData.records[0].id);
            } else {
              schoolId = Local.get('schoolId');
            }

            let currentSchoolName = myData.records.find(item => {
              return item.id == Local.get('schoolId');
            }); // console.log('currentSchoolName', currentSchoolName);

            this.props.layoutActions.ActionGetSchoolId(schoolId);
            this.setState({
              schoolList: myData.records,
              schoolId,
              currentSchoolName: currentSchoolName && currentSchoolName.schoolName || myData.records[0].schoolName,
              refresh_loading: false
            }, () => {
              _this.getDefaultDatas();
            });
          }
        }
      });
      resolve();
    }); // }
  }; //获取是否开启分校独立

  getSchoolIndependent = () => {
    return new Promise((resolve, reject) => {
      let params = {};
      params.companyId = this.state.companyId;

      let _this = this;

      getSchoolIndepent(params).then(res => {
        if (res.code == '1') {
          //1 开启 0 关闭
          if (res.data == 0) {
            this.getSelectedSchool();
            this.setState({
              showSchoolList: true
            });
          } else {
            this.getSelectedSchool();
            this.setState({
              showSchoolList: false
            });
          }
        } else {// console.log('未拿到分校独立信息res', res)
        }
      });
      resolve();
    });
  }; //判断当前域名是否分校域名

  getSelectedSchool = () => {
    let params = {};
    params.domain = window.location.host.indexOf('localhost') == -1 ? window.location.host : 'wxrcc.rel-s.yunduoketang.cn';
    selectedSchool(params).then(res => {
      // console.log('当前域名是否分校域名', res);
      if (res.code == '1' && res.data) {
        this.handleSchoolClick(res.data);
        this.setState({
          showSchoolList: false
        });
      } else {// console.log('未拿到当前域名是否分校域名res', res)
      }
    });
  }; // 判断是否开启注册功能

  getRegisterConfigFn = () => {
    return new Promise((resolve, reject) => {
      getRegisterConfig().then(res => {
        if (res.code == '1' && res.data) {
          Local.set('registerConfigFlag', res.data.closeFlag);
          this.setState({
            registerConfigFlag: res.data.closeFlag,
            registerConfig: res.data
          });
        }
      });
      resolve();
    });
  };
  getDefaultDatas = () => {
    // console.log('schoolId', this.state.schoolId);
    return new Promise((resolve, reject) => {
      //获取机构导航模板配置
      // this.getHeadConfig()
      // 配色
      this.getSystemColor(); // 获取题库权限设置

      this.getAllSubjectAuth(); // 头部菜单

      this.getMenuList('head'); // 底部菜单

      this.getMenuList('foot'); // 机构基本信息

      this.fetchBaseInfoData();

      if (this.state.userId) {
        //当前用户需要显示的信息
        this.fetchCurrentUserInfo(); //获取机构开通服务配置

        this.getServiceCofig();
      } // 用户配置信息


      this.fetchPersonConfigInfo(); // 获取标题配置信息
      // this.getDocTitleInfo();
      // 获取最近学习记录

      this.getLateLearn(); // 获取app下载信息

      this.getAPPConfig(); // 获取页尾信息

      let _that = this;

      if (getFoot == 0) {
        getFoot = 1;
        setTimeout(function () {
          _that.fetchSystemFooter();
        }, 2000);
      }

      resolve();
    });
  };
  getServiceCofig = () => {
    personalLeftMenu({
      domain: this.state.currentDomain
    }).then(res => {
      // console.log('机构开通服务----', res);
      if (res.success && res.data) {
        this.props.personalActions.GetServiceConfig(res.data);
      }
    });
  };
  getAllSubjectAuth = () => {
    let params = {};
    params.group = 0;
    querySuebjectLibAuth(params).then(res => {
      if (res.code == '1') {
        this.props.layoutActions.ActionSubjectAuth(res.data);
      }
    }).catch(err => {
      Promise.reject(err);
    });
  }; //获取导航数据   TEACHER_PAGE_INIT

  getMenuList = (menuType, parentId) => {
    let params = {
      // companyId: this.state.companyId,
      schoolId: this.state.schoolId,
      parentId: parentId || 0,
      menuType: menuType
    };
    queryMenuList(params).then(res => {
      if (res.code == '1') {
        TEACHER_PAGE_INIT().then(data => {// console.log(data)
        });
        let myData = res.data;

        if (menuType == 'head') {
          myData.map(item => {
            item.subMenu = [];
          });
          let currentMenu = myData.length && myData[0].pageHeadType === "SYS_PAGE_HEAD_HOME" ? 0 : undefined;

          if (Local.get('parentId')) {
            const currentMenuId = Local.get('parentId');

            if (Local.get('parentId') !== 'null') {
              currentMenu = myData.length && myData.findIndex(item => item.id == currentMenuId);
            }

            if (Local.get('parentId') === 'null' && myData.length && myData[0].pageHeadType === "SYS_PAGE_HEAD_HOME") {
              currentMenu = 0;
            }
          } else {
            if (this.props.location.pathname === '/home/index') {
              currentMenu = myData.length && myData[0].pageHeadType === "SYS_PAGE_HEAD_HOME" ? 0 : undefined;
            } else {
              currentMenu = Local.get('currentMenu');
            }
          } // console.log('currentMenu', currentMenu);


          this.props.layoutActions.ActionSetMenus(myData);
          this.setState({
            headMenuList: myData,
            currentMenu
          }, () => {
            this.getDocTitleInfo();
          });
        } else if (menuType == 'foot') {
          this.setState({
            footMenuList: myData
          });
        }
      }
    }).catch(err => {
      Promise.reject(err);
    });
  }; //获取页尾信息

  fetchSystemFooter = (id = 0) => {
    let params = {
      companyId: this.state.companyId,
      schoolId: this.state.schoolId,
      parentId: id
    };
    getSystemFooter(params).then(res => {
      if (res.code == '1' && res.data) {
        let tempData = id ? this.state.footerInfo : res.data;

        if (id) {
          let indx = tempData.menus.length && tempData.menus.findIndex(item => item.id == id);
          tempData.menus.length ? tempData.menus[indx].childrens = res.data : null;
        }

        this.setState({
          footerInfo: tempData
        }, () => {
          if (!id) {
            for (let value of this.state.footerInfo.menus) {
              value.parentId == 0 && value.count > 0 ? this.fetchSystemFooter(value.id) : null;
            }
          }
        });
      }
    }).catch(err => {
      Promise.reject(err);
    });
  }; //获取机构基本信息

  fetchBaseInfoData = () => {
    if (Local.get('schoolId')) {
      let params = {
        schoolId: Local.get('schoolId')
      };
      this.getFindMarket();
      getBaseInfo(params).then(res => {
        if (res.code == 1 && res.data) {
          let myData = res.data;
          Local.set('useLoginPage', myData.useLoginPage);
          this.setState({
            baseInfo: myData // sideLayerInfo: myData.markSet

          }); //判断是否显示仅供机构测试使用的警告
          // let showCompanyWarning = this.state.showCompanyWarning;

          let assignTime = new Date('2018/02/08').getTime();

          if (myData.domain.indexOf('.yunduoketang.') != -1) {
            if (myData.buyFlag != 1) {
              this.setState({
                showCompanyWarning: true,
                companyWarning: ''
              });
            } else {
              if (assignTime && new Date(myData.registTime.replace(/-/g, '/')).getTime() >= assignTime) {
                this.setState({
                  showCompanyWarning: true,
                  companyWarning: '当前网校仅供测试使用，更改成自主域名后才可以正式对外使用！'
                });
              }
            }
          }
        }
      });
    }
  };
  getFindMarket = () => {
    getFindMarket({
      schoolId: this.state.schoolId
    }).then(res => {
      if (res.code == '1') {
        this.setState({
          sideLayerInfo: res.data || {}
        });
      }
    });
  }; //获取当前用户需要显示的信息

  fetchCurrentUserInfo = () => {
    // console.log('fetchCurrentUserInfo')
    getCurrentUser().then(res => {
      if (res.code == 1 && res.data) {
        this.props.layoutActions.ActionCurrentUserInfo(res.data);
        this.setState({
          currentUserInfo: res.data,
          unreadMessage: res.data.unReadNum || 0
        });
      }
    });
  }; //校验用户是否需要更改密码(如果需要，跳转到修改密码页面)

  checkPwdUpdateStatus = async () => {
    let result;
    await checkPwdUpdate().then(res => {
      if (res.code == 1 && res.data) {
        result = res.data.pwdWxpired; // let resData = res.data;
        // let url = window.location.href;
        // //pwdWxpired值为1或2时需要跳转到修改密码页面（1需要强制修改密码，不修改无法进行其他操作；2不强制修改密码，还能进行其他操作）
        // if (resData.pwdWxpired == 1 || resData.pwdWxpired == 2) {
        //   this.props.personalActions.GetChangePasswordConfig(resData.pwdWxpired);
        //   if (url.indexOf('/personal/setting/account') == -1) {
        //     history.replace('/personal/setting/account')
        //   }
        // }
      }
    });
    return result;
  }; //获取用户配置信息

  fetchPersonConfigInfo = () => {
    getPersonConfig().then(res => {
      if (res.code == 1 && res.data) {
        this.setState({
          personConfigInfo: res.data
        });
      }
    });
  }; //分校下拉展示

  showDorpMenu = () => {
    this.setState({
      dropVisible: true
    });
  }; //选择分校

  handleSchoolClick = (item, type) => {
    // console.log('选择分校schoolId', item);
    let parmas = {
      schoolId: item.id
    };

    if (Local.get('token')) {
      saveSessionSchoolId(parmas).then(res => {
        if (res.code == 1 && res.data) {}
      });
    }

    type == 'changeSchool' ? Local.set('currentMenu', 0) : null;
    this.setState({
      currentSchoolName: item.schoolName,
      companyId: item.companyId || this.state.companyId,
      schoolId: item.id || item.schoolId,
      refresh_loading: true // dropVisible: false,

    }, () => {
      Local.set('schoolId', this.state.schoolId);
      this.props.layoutActions.ActionGetSchoolId(this.state.schoolId);
      this.getDefaultDatas();
      this.setState({
        refresh_loading: false
      });
      let url = decodeURI(window.location.href); // 为清除地址栏schoolId用
      // if (url.indexOf("schoolId") !== -1) {
      //   let url = window.location.href
      //   url = delUrlParmas('schoolId');
      //   // url = url.split("?")[0];
      //   window.location.href = url
      //   // history.push(url)
      // }
    });
  }; //点击导航菜单

  handleNavMenuClick = e => {
    this.setState({
      currentMenu: e.key
    }, () => {// console.log(e.key)
    });
  }; //点击菜单跳转

  handleMenuClick = (item, menuType, subIndex) => {
    // console.log('item.id', item, menuType, subIndex);
    let MenuClassName = subIndex == 0 ? 'menuIndex' : ' ';
    this.setState({
      currentMenu: subIndex
    });
    Local.set('currentMenu', subIndex.toString());
    Local.set('MenuClassName', MenuClassName);
    const menuObj = {
      'tikuIndex/toIndex': '/lib/subject',
      'liveOpenCourse/toOpenClass': '/openCourse',
      'classPackage/findAll': '/coursePackage/list',
      'companyGroup/groupIndex': '/group',
      'sysConfigTeacher/teachers': '/teachers',
      'studentStar/findByPage': '/StudentsVoice',
      'sysNews/list': '/news',
      'signup/toSigUpPage': '/apply',
      'question/comQuestionIndex': '/answerslist/0',
      'teacherSettle/teacherInfo': '/teacherLoginIn',
      'companyMemberConfig/toVip': '/vip'
    };

    if (item.menuUrl && item.menuUrl.indexOf('/s/pc/#') != -1) {
      window.open(item.menuUrl, '_blank');
      return;
    }

    if (item.menuUrl) {
      if (menuType == 'foot') {
        item.menuUrl = item.menuUrl + '/' + item.id;
      }

      if (menuObj[item.menuUrl]) {
        history.push(menuObj[item.menuUrl]);
      } else if (item.menuUrl.indexOf('sysConfigItem/showList') > -1) {
        history.location.pathname.includes('/course/detail') ? history.push('/course/list') : history.push(`/course/list?ramdomnum=${new Date().getTime()}`);
      } else if (!item.menuUrl) {
        history.push('/home/index'); // window.open(this.state.baseUrl + '/home/index', '_blan')
      } else {
        if (item.menuUrl.indexOf('http') == -1) {
          if (Local.get('userInfo') && JSON.parse(Decrypt(Local.get('userInfo'))).domain) {
            item.menuUrl = window.location.protocol + '//' + JSON.parse(Decrypt(Local.get('userInfo'))).domain + '/' + item.menuUrl;
          } else {
            item.menuUrl = this.state.baseUrl + '/' + item.menuUrl;
          }
        } else {
          item.menuUrl = item.menuUrl == 'http://' ? this.state.baseUrl : item.menuUrl;
        }

        if (!item.openType) {
          item.openType = menuType == 'foot' ? '_blank' : '_self'; //这么判断是为了和老网校保持一致
        } else {
          item.openType = '_' + item.openType;
        }

        window.open(`${item.menuUrl}${item.menuUrl.indexOf('?') !== -1 ? '&' : '?'}parentId=${item.id}`, item.openType);
      }
    } else {
      window.location.href = window.location.origin;
    }
  }; //鼠标移入菜单

  handleMenuMouseOver = item => {
    if (item.id) {
      let params = {
        // companyId: this.state.companyId,
        schoolId: this.state.schoolId,
        parentId: item.id,
        menuType: 'head'
      };
      queryMenuList(params).then(res => {
        if (res.code == '1') {
          if (res.data && res.data.length > 0) {
            let myData = res.data;
            let headMenuList = this.state.headMenuList;
            headMenuList.map(menu => {
              if (menu.id == item.id) {
                menu.subMenu = myData;
              }
            }); // console.log('headMenuList', headMenuList);

            this.setState({
              headMenuList: headMenuList
            });
          }
        }
      });
    }
  };
  getSystemColor = () => {
    let color = 'default';
    let params = {};
    params.schoolId = Local.get('schoolId') ? Local.get('schoolId') : this.state.schoolId;
    params.companyId = this.state.companyId;
    const colorObj = {
      'header-white': 'white',
      'header-cyan': 'cyan',
      'header-cyan-deep': 'cyanDeep',
      'header-green': 'green',
      'header-green-pale': 'greenPale',
      'header-red': 'red',
      'header-red-deep': 'redDeep',
      'header-gray': 'gray',
      'header-orange': 'orange',
      'header-orange-deep': 'orangeDeep',
      'header-blue': 'blue',
      'header-blue-pale': 'bluePale',
      'header-default': 'default',
      '': 'default'
    };
    querySystemColor(params).then(res => {
      // console.log(999, res)
      if (res.success) {
        color = colorObj[res.data];

        if (color == 'white' || color == 'gray') {
          this.setState({
            menuColor: 'light'
          });
        } else {
          this.setState({
            menuColor: 'dark'
          });
        }

        Local.set('main_color', color);
        document.body.style.setProperty('--themeColor', themeColor[color].themeColor);
        document.body.style.setProperty('--fizeColor', themeColor[color].fizeColor);
        document.body.style.setProperty('--headerBg', themeColor[color].headerBg);
        document.body.style.setProperty('--themeRgba', themeColor[color].themeRgba);
        document.body.style.setProperty('--linearColor', themeColor[color].linearColor);
      }
    });
    this.getHeadConfig();
  }; //退出登录

  logout = () => {
    loginOut().then(res => {
      let url = '';
      if (res.loginSchoolPath) url = res.loginSchoolPath;
      window.location.href = `${window.location.origin}${url}`;
      this.clearSomeCache();
    }).catch(err => Promise.reject(err));
  }; //注册（需要判断关闭了独立登陆页，useLoginPage是否使用登录页面 0否，1是）
  // toRegister = () => {
  //   console.log(1111)
  //   let hash = '';
  //   if (window.location.hash.indexOf('?code=') > -1) {
  //     hash = `${window.location.pathname}${window.location.hash.split('?')[0]}`
  //   } else {
  //     hash = `${window.location.pathname}${window.location.hash}`
  //   }
  //   let queryString = window.encodeURIComponent(hash)
  //   let baseInfo = this.state.baseInfo;
  //   if (baseInfo && baseInfo.useLoginPage == 1) {
  //     window.location.href = `${window.location.origin}/registerPage`
  //   } else {
  //     window.location.href = `${window.location.origin}?popwin=regist&returnUrl=${queryString}`
  //   }
  //   this.clearSomeCache();
  // }
  //登录（需要判断关闭了独立登陆页，useLoginPage是否使用登录页面 0否，1是）
  // toLogin = () => {
  //   let hash = '';
  //   if (window.location.hash.indexOf('?code=') > -1) {
  //     hash = `${window.location.pathname}${window.location.hash.split('?')[0]}`
  //   } else {
  //     hash = `${window.location.pathname}${window.location.hash}`
  //   }
  //   let queryString = window.encodeURIComponent(hash)
  //   let baseInfo = this.state.baseInfo;
  //   if (baseInfo && baseInfo.useLoginPage == 1) {
  //     window.location.href = `${window.location.origin}/loginPage?nqbcallback=${queryString}`
  //     // window.location.href = `${window.location.origin}/loginPage`
  //   } else {
  //     window.location.href = `${window.location.origin}?popwin=login&returnUrl=${queryString}`
  //   }
  //   this.clearSomeCache();
  // }
  //清空部分缓存

  clearSomeCache = () => {
    Local.remove('token');
    Local.remove('userInfo');
    Local.remove('schoolId');
    Local.remove('main_color');
    Local.remove('useLoginPage'); // Local.remove('refresh_token')

    removeAllCookie();
  }; //我的消息

  toMessage = () => {
    // window.location.href = `${this.state.baseUrl}/usersCenter?url=message`;
    history.push('/personal/message/detailslist?parentId=-1');
  }; //课程中心

  goCourse = () => {
    history.push('/personal/course/classTable?parentId=-1');
  };
  getConfigNodeFn = () => {
    getConfigNode().then(res => {
      if (res.code == '1') {
        let data = res.data || {};
        this.setState({
          domain: data.domain,
          liveDomain: data.liveDomain,
          liveYunId: data.liveYunId,
          _sessionId: data._sessionId,
          liveSessionId: data.liveSessionId,
          online_school_nodejs_domain: data.online_school_nodejs_domain
        }, () => {
          this.getNodeStatic();
        });
      }
    });
  };
  getNodeStatic = () => {
    // node 统计在线人数
    const {
      userId = "",
      schoolId
    } = this.state;
    const companyId = localStorage.getItem('userInfo') ? JSON.parse(Decrypt(localStorage.getItem('userInfo'))).companyId : 0;
    let online_companyid = companyId;
    let _company_id = companyId;
    let _school_id = schoolId;

    let _user_id = userId == 0 || userId == null ? '' : userId;

    let iplist_out = [];
    let domains = this.state.online_school_nodejs_domain,
        // 后台接口返回
    liveCompanyId = companyId,
        liveSchoolId = schoolId,
        // liveUserId = userId == 0 ? '' : userId,
    _sessionId = this.state._sessionId,
        liveSessionId = this.state.liveSessionId,
        liveDomain = this.state.liveDomain;

    if (typeof domains != 'undefined') {
      let split = domains.split(",");

      if (split.length > 0) {
        for (var i = 0; i < split.length; i++) {
          iplist_out.push("//" + split[i]);
        }
      }
    }

    ;
    let u_nodejs_online = this.state.currentDomain;
    let href_nodejs_online = iplist_out[online_companyid % iplist_out.length];
    let front_sessionid = "";
    setTimeout(() => {
      this.getdomain();

      if (typeof liveDomain === "string") {
        online_companyid = liveCompanyId;
        _company_id = liveCompanyId;
        _school_id = liveSchoolId; // _user_id = liveUserId;
      }

      try {
        front_sessionid = _sessionId;
      } catch (e) {// console.log(e);
      } // try {
      //   if (typeof liveSessionId === "string") {
      //     front_sessionid = liveSessionId;
      //   }
      //   if (typeof liveDomain === "string") {
      //     u_nodejs_online = liveDomain;
      //   }
      // } catch (e) {
      // }


      let socket_nodejs_online = io(href_nodejs_online, {
        query: `yunId=${this.getYunid()}&additional=5&domain=${u_nodejs_online}&sessionid=${front_sessionid}&userId=${_user_id}&schoolId=${_school_id}&companyId=${_company_id}&platform=pc`
      });

      window.onbeforeunload = () => {
        socket_nodejs_online.emit("leave", () => {});
      };

      socket_nodejs_online.on("out_online", () => {
        window.location.href = `/redirect/online?u=${u_nodejs_online}`;
      });
      socket_nodejs_online.on("front_logout", () => {
        try {
          this.refrenshPage();
        } catch (e) {// console.log(e);
        }
      });
    }, 3500);
  };
  getdomain = () => {
    let domain = this.state.currentDomain;
    domain = domain.replace("http://", "").replace("http://", "");

    if (domain.indexOf("/") > 0) {
      domain = domain.substring(0, domain.indexOf("/"));
    }

    if (domain.indexOf(":") > 0) {
      domain = domain.substring(0, domain.indexOf(":"));
    }

    return domain;
  };
  setCookie_nodejs_online = (name, value, day) => {
    let exp = new Date();
    exp.setTime(exp.getTime() + day * 24 * 60 * 60 * 1000);
    document.cookie = `${name}=${escape(value)};path=/;domain=.${this.getdomain()};expires=${exp.toGMTString()}`;
  };
  getCookie_nodejs_online = name => {
    let arr,
        reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
    if (arr = document.cookie.match(reg)) return arr[2];else return null;
  };
  getYunid = () => {
    try {
      if (typeof this.state.liveYunId === "string") {
        return this.state.liveYunId;
      }
    } catch (e) {// console.log(e);
    }

    if (this.getCookie_nodejs_online("yunId") == null || this.getCookie_nodejs_online("yunId") == "") {
      let uuid = this.makeUUID();
      this.setCookie_nodejs_online("yunId", uuid, 365 * 2);
      return uuid;
    } else {
      return this.getCookie_nodejs_online("yunId");
    }
  };
  makeUUID = () => {
    let S4 = () => {
      return ((1 + Math.random()) * 0x10000 | 0).toString(16).substring(1);
    };

    return S4() + S4() + S4() + S4() + S4() + S4() + S4() + S4();
  };
  refrenshPage = () => {
    window.location.reload();
  };
  goToAppDown = () => {
    window.open(`${window.location.origin}${window.location.pathname}#/appload`);
  }; // getTimeZoneConfig

  getZoneConfig = () => {
    getTimeZoneConfig().then(res => {
      if (res.code == 1) {
        this.props.layoutActions.ActionSetTimeZoneFlag(res.data);
      }
    });
  };

  render() {
    const {
      state
    } = this;
    const {
      baseInfo,
      schoolList,
      headMenuList,
      personConfigInfo,
      currentUserInfo,
      appConfig,
      showSchoolList,
      currentSchoolName,
      learnData,
      lateLearnShow,
      registerConfigFlag,
      headerConfig,
      dropVisible,
      currentMenu
    } = this.state;
    const {
      personal
    } = this.props;
    let showHeadFlag = window.location.href.indexOf('paperprint') == -1; // console.log('currentMenu--', currentMenu);
    // // 单试题隐藏底部 长试卷展示底部 272单试题, 271长试题
    // const footFlag = this.props.layout.subjectAuth && this.props.layout.subjectAuth.length && this.props.layout.subjectAuth[17].configItem == 272 && this.props.layout.subjectAuth && window.location.href.includes('/lib/subject/doing/');

    const splitHash = window.location.hash && window.location.hash.split('/').length && window.location.hash.split('/')[1];
    let LayoutBgColor = classnames({
      'bg-color-personal': splitHash == 'personal',
      'bg-color-questionbank': splitHash == 'lib'
    }); //仅供机构测试使用的默认警告信息

    const defaultCompanyWarning = <span data-inspector-line="1455" data-inspector-column="6" data-inspector-relative-path="src\\containers\\Layout\\index.jsx" className="company-warning-text">当前网校为<i data-inspector-line="1455" data-inspector-column="50" data-inspector-relative-path="src\\containers\\Layout\\index.jsx">试用版</i>网校，仅供机构测试使用，更改成自主域名后才可以正式对外使用！</span>; // let messagesLan = {}
    // messagesLan['en'] = en_US
    // messagesLan['zh'] = zh_CN

    const pathname = window.location.href.split('#')[1]; // window.tt = this;

    return (// <IntlProvider locale={this.state.lang} messages={messagesLan[this.state.lang]}>
      <ConfigProvider data-inspector-line="1466" data-inspector-column="6" data-inspector-relative-path="src\\containers\\Layout\\index.jsx" locale={zhCN}>
        {this.state.swithLoading ? <SpinLoading data-inspector-line="1467" data-inspector-column="35" data-inspector-relative-path="src\\containers\\Layout\\index.jsx" /> : <div data-inspector-line="1467" data-inspector-column="53" data-inspector-relative-path="src\\containers\\Layout\\index.jsx" className="layout" ref={e => this.scroll = e}>
          {!this.props.layout.flagHideHead && <div data-inspector-line="1470" data-inspector-column="12" data-inspector-relative-path="src\\containers\\Layout\\index.jsx" style={{
            'background': '#fff',
            position: 'relative',
            zIndex: 2
          }}>
              {//提示仅供机构测试使用的警告
            state.showCompanyWarning ? <Alert data-inspector-line="1473" data-inspector-column="18" data-inspector-relative-path="src\\containers\\Layout\\index.jsx" className="company-warning-title" description={state.companyWarning || defaultCompanyWarning} type="warning" showIcon closable /> : null}

              {//典雅 { 1=典雅页头 2=清风页头 3=精致页头 } ,
            headerConfig.headTemplateId == 1 && showHeadFlag && <DelicateHeader data-inspector-line="1483" data-inspector-column="68" data-inspector-relative-path="src\\containers\\Layout\\index.jsx" {...{
              baseInfo,
              schoolList,
              headMenuList,
              personConfigInfo,
              currentUserInfo,
              appConfig,
              personal,
              showSchoolList,
              currentSchoolName,
              registerConfigFlag,
              learnData,
              lateLearnShow,
              dropVisible,
              currentMenu
            }} changeMenu={this.changeMenu} goToAppDown={this.goToAppDown} handleNavMenuClick={this.handleNavMenuClick} handleMenuMouseOver={this.handleMenuMouseOver} handleSchoolClick={this.handleSchoolClick} handleMenuClick={this.handleMenuClick} history={this.props.history} handleSwitchLang={this.handleSwitchLang} showDorpMenu={this.showDorpMenu} langText={this.state.langText} />}

              {//精致
            headerConfig.headTemplateId == 3 && showHeadFlag ? window.location.href.indexOf('/home/index') > 0 && headerConfig.headTemplateId != 1 ? <WindHeader data-inspector-line="1501" data-inspector-column="157" data-inspector-relative-path="src\\containers\\Layout\\index.jsx" {...{
              baseInfo,
              schoolList,
              headMenuList,
              personConfigInfo,
              currentUserInfo,
              appConfig,
              personal,
              showSchoolList,
              currentSchoolName,
              registerConfigFlag,
              learnData,
              lateLearnShow,
              dropVisible,
              currentMenu
            }} changeMenu={this.changeMenu} goToAppDown={this.goToAppDown} handleNavMenuClick={this.handleNavMenuClick} handleMenuMouseOver={this.handleMenuMouseOver} handleSchoolClick={this.handleSchoolClick} handleMenuClick={this.handleMenuClick} history={this.props.history} handleSwitchLang={this.handleSwitchLang} showDorpMenu={this.showDorpMenu} langText={this.state.langText} /> : <DelicateHeader data-inspector-line="1516" data-inspector-column="18" data-inspector-relative-path="src\\containers\\Layout\\index.jsx" {...{
              baseInfo,
              schoolList,
              headMenuList,
              personConfigInfo,
              currentUserInfo,
              appConfig,
              personal,
              showSchoolList,
              currentSchoolName,
              registerConfigFlag,
              learnData,
              lateLearnShow,
              dropVisible,
              currentMenu
            }} changeMenu={this.changeMenu} goToAppDown={this.goToAppDown} handleNavMenuClick={this.handleNavMenuClick} handleMenuMouseOver={this.handleMenuMouseOver} handleSchoolClick={this.handleSchoolClick} handleMenuClick={this.handleMenuClick} history={this.props.history} showDorpMenu={this.showDorpMenu} handleSwitchLang={this.handleSwitchLang} langText={this.state.langText} /> : null}

              {//清风
            headerConfig.headTemplateId == 2 && showHeadFlag && <ElegantHeader data-inspector-line="1533" data-inspector-column="68" data-inspector-relative-path="src\\containers\\Layout\\index.jsx" {...{
              baseInfo,
              schoolList,
              headMenuList,
              personConfigInfo,
              currentUserInfo,
              appConfig,
              personal,
              showSchoolList,
              currentSchoolName,
              registerConfigFlag,
              learnData,
              lateLearnShow,
              dropVisible,
              currentMenu
            }} changeMenu={this.changeMenu} goToAppDown={this.goToAppDown} handleNavMenuClick={this.handleNavMenuClick} handleMenuMouseOver={this.handleMenuMouseOver} handleSchoolClick={this.handleSchoolClick} handleMenuClick={this.handleMenuClick} history={this.props.history} showDorpMenu={this.showDorpMenu} handleSwitchLang={this.handleSwitchLang} langText={this.state.langText} />}
            </div> || null}
          {!this.state.refresh_loading && !this.state.refresh_token_loading && Local.get('token') ? <div data-inspector-line="1552" data-inspector-column="14" data-inspector-relative-path="src\\containers\\Layout\\index.jsx" className={LayoutBgColor} style={{
            minHeight: this.state.clientHeight
          }}>
                <RouterView data-inspector-line="1555" data-inspector-column="16" data-inspector-relative-path="src\\containers\\Layout\\index.jsx" routes={this.props.routes} />
              </div> : <SpinLoading data-inspector-line="1557" data-inspector-column="14" data-inspector-relative-path="src\\containers\\Layout\\index.jsx" />}
          {!this.props.layout.flagHideFoot && <Footer data-inspector-line="1559" data-inspector-column="46" data-inspector-relative-path="src\\containers\\Layout\\index.jsx" footerInfo={state.footerInfo} footMenuList={state.footMenuList} /> || null}
          {!this.state.refresh_loading && !this.state.refresh_token_loading && <LoginRegister data-inspector-line="1560" data-inspector-column="81" data-inspector-relative-path="src\\containers\\Layout\\index.jsx" registerConfig={this.state.registerConfig} /> || null}
          <SideLayer data-inspector-line="1561" data-inspector-column="10" data-inspector-relative-path="src\\containers\\Layout\\index.jsx" sideLayerInfo={state.sideLayerInfo}></SideLayer>
        </div>}
      </ConfigProvider> // </IntlProvider>

    );
  }

}

function mapStateToProps(state) {
  // console.log(state);
  return {
    layout: state.layout,
    currentUserInfo: state.layout.currentUserInfo,
    personal: state.personal,
    isBottom: state.payment.isBottom,
    schoolId: state.layout.schoolId
  };
}

function mapDispatchToProps(dispatch) {
  return {
    layoutActions: bindActionCreators(layoutActions, dispatch),
    isBottomActions: bindActionCreators(isBottomActions, dispatch),
    personalActions: bindActionCreators(personalActions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Layout));